<template>
  <div class="page">

    <div class="content-logo">
    <img class="wb-logo" src="../assets/autoconta_sin_fondo.png" alt="AutoConta" />
  </div>


    <div class="content">
      <div class="welcome-band">

        <div class="wb-left">
          <div class="wb-text">
            <div class="wb-title">¡Bienvenido!</div>
            <div class="wb-sub">¿Qué deseas hacer hoy?</div>
            <div class="wb-fecha">{{ fechaHoy }}</div>
          </div>
        </div>

        <div class="wb-right">
          <!-- SEMÁFORO -->
          <div class="ind" :style="{
            background: colorFondo(semaforo.emitidos),
            borderColor: colorBorde(semaforo.emitidos)
          }">
            <div class="ind-dot" :style="{ background: colorDot(semaforo.emitidos) }"></div>
            <div class="ind-info">
              <span class="ind-tipo" :style="{ color: colorTipo(semaforo.emitidos) }">Emitidos</span>
              <span class="ind-fecha" :style="{ color: colorFecha(semaforo.emitidos) }">
                {{ formatFecha(descarga.emitidos?.ultimaFecha) }}
              </span>
              <span class="ind-label" :style="{ color: colorLabel(semaforo.emitidos) }">
                {{ labelEstado(semaforo.emitidos) }}
              </span>
            </div>
          </div>

          <div class="ind" :style="{
            background: colorFondo(semaforo.recibidos),
            borderColor: colorBorde(semaforo.recibidos)
          }">
            <div class="ind-dot" :style="{ background: colorDot(semaforo.recibidos) }"></div>
            <div class="ind-info">
              <span class="ind-tipo" :style="{ color: colorTipo(semaforo.recibidos) }">Recibidos</span>
              <span class="ind-fecha" :style="{ color: colorFecha(semaforo.recibidos) }">
                {{ formatFecha(descarga.recibidos?.ultimaFecha) }}
              </span>
              <span class="ind-label" :style="{ color: colorLabel(semaforo.recibidos) }">
                {{ labelEstado(semaforo.recibidos) }}
              </span>
            </div>
          </div>

          <q-btn v-if="solicitudDisponible" flat round dense icon="mdi-plus-circle-outline" size="md" color="grey-7"
            @click="crearSolicitud">
            <q-tooltip content-style="font-size:13px">
              Crear solicitud de descarga
            </q-tooltip>
          </q-btn>

        </div>

      </div>

      <div class="sec">
        <div class="sec-hdr">
          <span class="sec-name">Menú</span>
          <div class="sec-line"></div>
        </div>
        <div class="cards">
          <div class="card" v-for="m in modulos" :key="m.name" @click="m.action()">
            <div class="card-top">
              <div class="card-icon">
                <q-icon :name="m.icon" size="25px" style="color:#662e91" />
              </div>
              <span class="card-arr">→</span>
            </div>
            <div>
              <div class="card-label">{{ m.name }}</div>
              <div class="card-sub">{{ m.sub }}</div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      descarga: { emitidos: null, recibidos: null },
      semaforo: { emitidos: null, recibidos: null },
      modulos: [
        {
          name: 'Pólizas',
          sub: 'Registro contable',
          icon: 'mdi-file-document-multiple-outline',
          action: () => {
            this.$store.state.listaPolizasStore = []
            this.$router.push({ name: 'Polizas' })
          }
        },
        {
          name: 'Reportes',
          sub: 'Balanza y estados',
          icon: 'mdi-file-chart-outline',
          action: () => this.$router.push({ name: 'Balanza' })
        },
        {
          name: 'Reportes Especiales',
          sub: 'Costo producción y venta',
          icon: 'mdi-file-chart-check-outline',
          action: () => this.$router.push({ name: 'EstadoCostoProduccionVenta' })
        },
        {
          name: 'Catálogo de Cuentas',
          sub: 'Plan contable',
          icon: 'mdi-clipboard-list-outline',
          action: () => {
            this.$store.state.listaCatalogoCuentasStore = []
            this.$router.push({ name: 'CatalogoCuentas' })
          }
        },
        {
          name: 'Bancos',
          sub: 'Cuentas bancarias',
          icon: 'mdi-bank',
          action: () => this.$router.push({ name: 'Bancos' })
        },
        {
          name: 'Descargas',
          sub: 'Solicitudes al SAT',
          icon: 'mdi-arrow-down-bold-box',
          action: () => this.$router.push({ name: 'DescargasScraper' })
        },
        {
          name: 'Comprobantes',
          sub: 'Contabilizados',
          icon: 'mdi-list-status',
          action: () => this.$router.push({ name: 'ComprobantesContabilizados' })
        },
        {
          name: 'Centro de Costos',
          sub: 'Gestión de costos',
          icon: 'mdi-clipboard-multiple',
          action: () => this.$router.push({ name: 'ListCentroCostos' })
        },
      ]
    }
  },

  computed: {
    token() {
      return this.$store.state.usuario;
    },
    fechaHoy() {
      return new Date().toLocaleDateString('es-MX', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
      })
    },
    rutaDescargas() {
      return this.$store.state.rutaDescargas;
    },
    fechaMasVieja() {
      const fe = this.descarga.emitidos?.ultimaFecha
      const fr = this.descarga.recibidos?.ultimaFecha
      if (!fe && !fr) return null
      if (!fe) return fr
      if (!fr) return fe
      return new Date(fe) < new Date(fr) ? fe : fr
    },
    solicitudDisponible() {
      if (!this.fechaMasVieja) return false
      const hoy = new Date()
      const fecha = new Date(this.fechaMasVieja)
      const esHoy = (
        fecha.getDate()     === hoy.getDate()   &&
        fecha.getMonth()    === hoy.getMonth()  &&
        fecha.getFullYear() === hoy.getFullYear()
      )
      const emitidosAlDia  = this.semaforo.emitidos  === 'verde'
      const recibidosAlDia = this.semaforo.recibidos === 'verde'
      return !esHoy && !(emitidosAlDia && recibidosAlDia)
    },
  },

  created() {
    this.GetEmpresa();
    this.cargarSemaforo();
  },

  methods: {
    async GetEmpresa() {
      try {
        let response = await axios.get('Empresa/GetEmpresa/erp_' + this.token.rfc + '/' + this.token.rfc);
        this.$store.state.empresaStore = response.data
      } catch (error) {
        console.log(error);
      }
    },

    async cargarSemaforo() {
      try {
        const rfc = this.$store.state.usuario.rfc
        if (!rfc) return
        const { data } = await axios.get(this.rutaDescargas +
          `Descargas/GetUltimaDescarga/${rfc}`
        )
        this.descarga = { emitidos: data.emitidos, recibidos: data.recibidos }
        this.semaforo = { emitidos: data.emitidos?.semaforo, recibidos: data.recibidos?.semaforo }
      } catch (e) {
        console.error('Semáforo no disponible', e)
      }
    },

    async crearSolicitud() {
      if (!this.fechaMasVieja) {
        this.$q.notify({ type: 'warning', message: 'No hay fecha disponible para crear la solicitud', position: 'top-right' })
        return
      }
      this.$q.loading.show({ message: 'Generando solicitud...' })
      const objeto = {
        Rfc: this.$store.state.usuario.rfc,
        razon_social: this.$store.state.empresaStore.nombre,
        fecha_de_la_solicitud: this.fechaMasVieja,
        tipo: 'Ambos'
      }
      try {
        await axios.post(this.rutaDescargas + 'Descargas/PostSolicitudDescargarSignalR', objeto)
        this.$q.notify({ type: 'positive', message: 'Solicitud de descarga creada correctamente.', position: 'top-right' })
        this.$q.loading.hide()
      } catch {
        this.$q.notify({ type: 'negative', message: 'Error al registrar la solicitud', position: 'top-right' })
        this.$q.loading.hide()
      }
    },

    // Colores semáforo
    colorDot(v)   { return { rojo: '#E24B4A', amarillo: '#EF9F27', verde: '#639922' }[v] || '#ccc' },
    colorFondo(v) { return { rojo: '#FCEBEB', amarillo: '#FAEEDA', verde: '#EAF3DE' }[v] || '#f4f5f7' },
    colorBorde(v) { return { rojo: '#F09595', amarillo: '#FAC775', verde: '#97C459' }[v] || '#e3e3e3' },
    colorTipo(v)  { return { rojo: '#791F1F', amarillo: '#633806', verde: '#27500A' }[v] || '#aaa' },
    colorFecha(v) { return { rojo: '#A32D2D', amarillo: '#854F0B', verde: '#3B6D11' }[v] || '#111' },
    colorLabel(v) { return { rojo: '#A32D2D', amarillo: '#854F0B', verde: '#3B6D11' }[v] || '#aaa' },
    labelEstado(v){ return { rojo: 'Desactualizado', amarillo: 'Por actualizar', verde: 'Al día' }[v] || '—' },
    formatFecha(fecha) {
      if (!fecha) return '—'
      return new Date(fecha).toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' })
    },
  }
}
</script>

<style scoped>
.page {
  background: #f4f5f7;
}
.content-logo {
  padding: 40px 0px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.content {
  padding: 40px 100px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.welcome-band {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;
  width: 100%;
}

.wb-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.wb-logo {
  height: 150px;
  width: auto;
  object-fit: contain;
  padding: 0px 0px;
}

.wb-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.wb-title {
  font-size: 32px;
  font-weight: 600;
  color: #303030;
}

.wb-sub {
  font-size: 16px;
  color: rgba(83, 83, 83, 0.7);
}

.wb-fecha {
  font-size: 11px;
  color: rgba(80, 80, 80, 0.5);
  margin-top: 1px;
}

.wb-right {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
}

/* SEMÁFORO */
.ind {
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 155px;
  border: 0.5px solid transparent;
}

.ind-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ind-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ind-tipo {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: .05em;
  font-weight: 600;
}

.ind-fecha {
  font-size: 12px;
  font-weight: 600;
}

.ind-label {
  font-size: 11px;
  font-weight: 600;
}

/* SECCIÓN */
.sec {
  display: flex;
  flex-direction: column;
}

.sec-hdr {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.sec-line {
  flex: 1;
  height: 0.5px;
  background: #ddd;
}

.sec-name {
  font-size: 11px;
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: .07em;
  font-weight: 600;
  white-space: nowrap;
}

/* CARDS */
.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 12px;
}

.card {
  background: #fff;
  border: 0.5px solid #e3e3e3;
  border-radius: 16px;
  padding: 20px 18px 18px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 14px;
  transition: border-color .15s, background .15s;
}

.card:hover {
  border-color: #bbb;
  background: #fafafa;
}

.card-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.card-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: #F0E6F8;
}

.card-arr {
  font-size: 18px;
  color: #ddd;
  transition: color .15s;
  margin-top: 2px;
}

.card:hover .card-arr {
  color: #662e91;
}

.card-label {
  font-size: 16px;
  font-weight: 600;
  color: #111;
  line-height: 1.3;
}

.card-sub {
  font-size: 14px;
  color: #aaa;
  margin-top: 3px;
}
</style>